import type { AccordionHeaderPassThroughOptions } from "primevue/accordionheader";

export const accordionheader: AccordionHeaderPassThroughOptions = {
  root: ({ context }) => ({
    class: [
      // Layout
      "flex flex-row-reverse items-center justify-end gap-2 py-2 px-3 w-full",

      // Typography
      "font-semibold",

      // Color
      "hover:text-contrast-bitter-sweet",

      // Border
      "rounded-md",

      // States
      {
        "text-contrast-bitter-sweet bg-system-bg": context.active,
        "text-system-grey": !context.active
      }
    ]
  })
};
